module.exports = __webpack_public_path__ + "static/media/Painted_stacked_stone_w_painted_shadow_on_smooth_board_2009.bfbe7c2d.webp";